import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../shared/core/http.service';
import { ViewingSessionModel } from './viewingsession.model';



@Injectable()
export class DocumentService {
  private documentsUrl = new URL('documents', process.env.API_URL).toString();   
  constructor(private httpClient: Http, private _httpService: HttpService) { }

  // Gets a list of available documents from the ASP.NET application server. In
  // this sample, the ASP.NET application server just returns a simple list of
  // static filenames. In a real application, your API may return something
  // different, such as database ids with associated document metadata. And your
  // real application API would only return documents which your user has access
  // to.
  getDocuments(): Observable<string[]> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let resp =  this.httpClient.get(this.documentsUrl)
    .map(response => response.json() as string[]) // Convierte la respuesta a string[]
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    return resp
  }

  // Asks the ASP.NET application server to create a viewing session for a
  // particular document. In this sample, documents are identified by a
  // filename. In a real application, you might use something else, such as a
  // database identifier, to identify your documents. The application server
  // will then make a request to the PrizmDoc Viewer backend to create a new
  // viewing session for the specified document, returning a new
  // viewingSessionId. This viewingSessionId is what your Angular app needs in
//   // order to instantiate the viewer.
  createViewingSessionForDocument(filename: string): Observable<any> {
    let headers = new Headers({'Content-Type': 'application/json'});
    let resp = this.httpClient.post(`${this.documentsUrl}/${filename}/beginViewing`,null, {headers})
      .map((response) => {
          response.json()
        }) 
      .map((data: any) => {
        data.viewingSessionId
    
      })
      .catch((error: any) => {
        return Observable.throw(error.message || error); // Maneja errores
      });

       return  resp;
  }

  errorCustomHandler(error:Response):Observable<Response>{
    if(error.status === 401 && error.url.endsWith('GenerateToken')){
        return Observable.throw(error || 'Server error');
    }
    if(error.status === 401){
        console.log('Redirect to Home: Error 401 unauthorized');                       
        window.location.href = window.location.origin;   
    }
    return Observable.throw(error || 'Server error');
    }

    private handleError(error: Response) {
        console.error('companyService.handleError(...() >>> There has been an error while calling api, error:', error);
        return Observable.throw(error || 'Server error');
    }

    createViewingSession(filename: string): Observable<ViewingSessionModel> {
      return this._httpService.httpPost(`${this.documentsUrl}/${filename}/beginViewing`, {})
          .map((response: Response) => {
              return this.mapViewingSession(response);
          })
          .do(data => data)
  }

  mapViewingSession(response: Response): ViewingSessionModel {
    var data = response.json();
    let viewingSessionModel: ViewingSessionModel = new ViewingSessionModel();
    viewingSessionModel.viewingSessionId = data.viewingSessionId;
    return viewingSessionModel;
}


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/docviewer/document.service.ts